import { Box, Icon, Skeleton } from "@outschool/backpack";
import { PastTeachersForParentProfileQuery } from "@outschool/gql-frontend-generated";
import { faShare } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { TrackedButton } from "@outschool/ui-components-shared";
import { SimpleTeacherCard } from "@outschool/ui-components-website";
import React from "react";

const HEADSHOT_SIZE = 112;

type Props = {
  teacher: PastTeachersForParentProfileQuery["pastTeachersForParentProfile"][0];
  onShare: () => void;
  onWatchVideo: () => void;
  isCurrentUsersProfile: boolean;
};

export function TeacherCard({
  teacher,
  onShare,
  onWatchVideo,
  isCurrentUsersProfile
}: Props) {
  const { t } = useTranslation(
    "client\\components\\teacher\\MyTeachersSection\\TeacherCard"
  );

  return (
    <Box flex sx={{ flexDirection: "column", gap: "1rem", minWidth: "144px" }}>
      <SimpleTeacherCard teacher={teacher} onWatchVideo={onWatchVideo} />
      {isCurrentUsersProfile && (
        <TrackedButton
          trackingName="share_button"
          color="primary"
          size="small"
          variant="outlined"
          onClick={onShare}
          sx={{
            alignSelf: "center",
            display: "flex",
            gap: "1rem",
            width: 125
          }}
        >
          {t("Share")}
          <Icon icon={faShare} />
        </TrackedButton>
      )}
    </Box>
  );
}

export function LoadingTeacherCard() {
  return (
    <Skeleton
      variant="circular"
      width={HEADSHOT_SIZE}
      height={HEADSHOT_SIZE}
      component="div"
      sx={{ flexShrink: 0 }}
    />
  );
}
